import each from 'lodash/each';
import groupBy from 'lodash/groupBy';

import logger from '../../utils/logger';

class Twitter {
  _init(state, commit, id) {
    if (state.currentIds.lastTwitter !== id) {
      twq('init', id);
      commit('trackId', { property: 'lastTwitter', value: id });
      logger.log(`${id} initialize.`);
    } else {
      logger.log(`${id} already initialized.`);
    }
  }

  _payload(state, status) {
    return {
      content_ids: [state.campaign.slug],
      content_type: 'product',
      content_name: state.campaign.name,
      content_category: state.campaign.category,
      currency: 'USD',
      value: parseFloat(state.product.price),
      status,
    };
  }

  _trackEvent(state, commit, id, twitEvent, payload, type, message) {
    this._init(state, commit, id)

    twq('track', 'ViewContent', payload);

    logger.log(`${type} ${id} ${message} event with payload:`);
    logger.log(payload);
  }

  clientViewSales({ state, commit }) {
    logger.groupCollapsed('Client Twitter');

    let idGlobal = state.campaign.tracking.global.twitter,
      idCampaign = state.campaign.tracking.campaign.twitter,
      viewContent = this._payload(state, 'viewed');

    if (logger.checkCampaign(idCampaign)) {
      this._trackEvent(state, commit, idCampaign, 'ViewContent', viewContent, 'Campaign specific', 'view content');
    }

    if (logger.checkGlobal(idGlobal, idCampaign)) {
      this._trackEvent(state, commit, idGlobal, 'ViewContent', viewContent, 'Global', 'view content');
    }

    logger.groupEnd();
  }

  clientViewThankYou({ state, commit }) {
    logger.groupCollapsed('Client Twitter');

    each(state.order.orders, order => {
      logger.groupCollapsed(order.campaign_name);

      let idGlobal = state.order.tracking[order.analytics_cid].global.twitter,
        idCampaign = state.order.tracking[order.analytics_cid].campaign.twitter,
        purchase = {
          value: Math.round((order.sale_total + order.shipping_discount - order.shipping_total) * 100) / 100,
          currency: 'USD',
          content_ids: [order.campaign_slug],
          content_type: 'product',
          content_name: order.campaign_name,
          num_items: 0,
          order_id: state.order.order_lookup_number,
          status: 'purchased',
        };

      each(order.products, product => {
        purchase.num_items += product.quantity;
      });

      if (logger.checkCampaign(idCampaign)) {
        this._trackEvent(state, commit, idCampaign, 'Purchase', purchase, 'Campaign specific', 'purchase');
      }

      if (logger.checkGlobal(idGlobal, idCampaign)) {
        this._trackEvent(state, commit, idGlobal, 'Purchase', purchase, 'Global', 'purchase');
      }

      logger.groupEnd();
    });

    logger.groupEnd();
  }

  clientAddToCart({ state, commit }) {
    logger.groupCollapsed('Client Twitter');

    let idGlobal = state.campaign.tracking.global.twitter,
      idCampaign = state.campaign.tracking.campaign.twitter,
      addToCart = this._payload(state, 'in cart');

    if (logger.checkCampaign(idCampaign)) {
      this._trackEvent(state, commit, idCampaign, 'AddToCart', addToCart, 'Campaign specific', 'add to cart');
    }

    if (logger.checkGlobal(idGlobal, idCampaign)) {
      this._trackEvent(state, commit, idGlobal, 'AddToCart', addToCart, 'Global', 'add to cart');
    }

    logger.groupEnd();
  }

  clientInitiateCheckout({ state, commit }) {
    logger.groupCollapsed('Client Twitter');

    each(groupBy(state.cart.items, 'analytics_cid'), group => {
      let firstItem = group[0],
        idGlobal = state.cart.tracking[firstItem.analytics_cid].global.twitter,
        idCampaign = state.cart.tracking[firstItem.analytics_cid].campaign.twitter,
        initiateCheckout = {
          content_ids: [firstItem.campaign_slug],
          content_type: 'product',
          content_name: firstItem.campaign_name,
          content_category: firstItem.campaign_category,
          currency: 'USD',
          value: 0,
          num_items: 0,
          status: 'on checkout',
        }

      logger.groupCollapsed(firstItem.campaign_name);

      each(group, item => {
        initiateCheckout.value += item.price;
        initiateCheckout.num_items += item.quantity;
      });

      initiateCheckout.value = Math.round(initiateCheckout.value * 100) / 100;

      if (logger.checkCampaign(idCampaign)) {
        this._trackEvent(state, commit, idCampaign, 'InitiateCheckout', initiateCheckout, 'Campaign specific', 'initiate checkout');
      }

      if (logger.checkGlobal(idGlobal, idCampaign)) {
        this._trackEvent(state, commit, idGlobal, 'InitiateCheckout', initiateCheckout, 'Global', 'initiate checkout');
      }

      logger.groupEnd();
    });

    logger.groupEnd();
  }
};

export default new Twitter();